import { AuthService } from "./auth";
import { SchoolsService } from "./schools";

export * from "./schools";
export * from "./auth";

export const SERVICES = [
    SchoolsService,
    AuthService,
];
